<template>
	<div class="gtm-dashboard">
		<report-section
			v-for="section in sections"
			:key="section.uuid"
			:section="section"
			:hospital-id="hospitalId"
			:listing-id="listingId"
			:organisation-id="organisationId"
		></report-section>
	</div>
</template>

<script>
import ReportSection from "./ReportSection";

export default {
	name: "LayoutsPage",
	components: {
		ReportSection
	},
	props: {
		page: {
			type: Object,
			default: () => null
		},
		hospitalId: {
			type: Number,
			default: () => null
		},
		listingId: {
			type: Number,
			default: () => null
		},
		organisationId: {
			type: Number,
			default: () => null
		}
	},
	computed: {
		sections() {
			return this.layout;
		},
		layout() {
			return JSON.parse(this.page.layout);
		}
	},
	methods: {
		issplit(row) {
			if (row.length >= 1) {
				const { type } = row[0];
				return type === "split" ? "page-break" : null;
			}
		}
	}
};
</script>
